// src/hooks/useBookingStatusMonitor.js
//
// Starea programării lecțiilor (în așteptare / programat / necesită atenție)
// pentru fiecare elev, de la backend, reîmprospătată periodic și la revenirea
// în tab. Folosită în lista de studenți și în membrii grupei, doar pentru
// admin și manager.

import { useCallback, useEffect, useMemo, useState } from "react";

import { getBookingStatuses } from "../api/bookingMonitorService";
import { indexBookingStatuses } from "../utils/bookingStatus";

export const BOOKING_STATUS_REFRESH_MS = 5 * 60 * 1000;

const EMPTY = { enabled: false, byUser: new Map() };

export function useBookingStatusMonitor(canSee) {
   const [monitor, setMonitor] = useState(EMPTY);

   useEffect(() => {
      if (!canSee) {
         setMonitor(EMPTY);
         return undefined;
      }

      let cancelled = false;
      const load = () =>
         getBookingStatuses()
            .then((payload) => {
               if (cancelled) return;
               setMonitor({
                  enabled: Boolean(payload?.enabled),
                  byUser: indexBookingStatuses(payload),
               });
            })
            .catch(() => {});

      load();
      const intervalId = window.setInterval(load, BOOKING_STATUS_REFRESH_MS);
      const onVisible = () => {
         if (document.visibilityState === "visible") load();
      };
      document.addEventListener("visibilitychange", onVisible);

      return () => {
         cancelled = true;
         window.clearInterval(intervalId);
         document.removeEventListener("visibilitychange", onVisible);
      };
   }, [canSee]);

   const stateOf = useCallback(
      (student) => monitor.byUser.get(String(student?.id)) || null,
      [monitor],
   );

   return useMemo(
      () => ({ enabled: monitor.enabled, byUser: monitor.byUser, stateOf }),
      [monitor, stateOf],
   );
}

/** Elevii care au exact starea aleasă (sau toți, fără filtru). */
export function filterStudentsByBookingStatus(students, byUser, statusFilter) {
   if (!statusFilter) return students || [];
   return (students || []).filter(
      (student) => byUser?.get(String(student?.id))?.status === statusFilter,
   );
}
